module.exports = __webpack_public_path__ + "img/keycap-digit-four.0e2c9de3.png";